export default __webpack_public_path__ + "assets/2fc734.png";